import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import GlobalBreadcrumbs from "src/shared/components/Breadcrumbs/components/GlobalBreadcrumbs";
import MainOutlet from "./MainOutlet";
import { Aside } from ".";

export const PageLayout = () => {
  return (
    <Box
      id="page"
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Aside />
      <MainOutlet id="main">
        <GlobalBreadcrumbs />
        <Box sx={{ flex: 1, minHeight: 0, paddingTop: "1.5rem" }}>
          <Outlet />
        </Box>
      </MainOutlet>
    </Box>
  );
};
